//
//
//
//

export default {
  mounted () {
    this.$nextTick(() => {
      this.$parent.rerender()
    })
  },
  beforeDestroy () {
    const $parent = this.$parent
    this.$nextTick(() => {
      $parent.rerender()
    })
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/swiper/swiper-item.vue